import React from 'react';

import Box from '@mui/material/Box';

import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
}));

const EveryQuarter = () => {
  const { classes } = useStyles();

  return <Box id='every-quarter' className={classes.root}></Box>;
};

export default EveryQuarter;
